import { render, staticRenderFns } from "./AlModal.vue?vue&type=template&id=28d3a73e&"
import script from "./AlModal.vue?vue&type=script&lang=js&"
export * from "./AlModal.vue?vue&type=script&lang=js&"
import style0 from "./AlModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports